var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"app-sidebar",class:{ 'app-sidebar__open': _vm.showSidebar }},[_c('ul',{staticClass:"app-sidebar__menu"})])}
var staticRenderFns = []

export { render, staticRenderFns }